import { render, staticRenderFns } from "./BuildApp.vue?vue&type=template&id=30a59145&scoped=true&"
import script from "./BuildApp.vue?vue&type=script&lang=js&"
export * from "./BuildApp.vue?vue&type=script&lang=js&"
import style0 from "./BuildApp.vue?vue&type=style&index=0&lang=css&"
import style1 from "./BuildApp.vue?vue&type=style&index=1&id=30a59145&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a59145",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardActions,VDialog,VSelect,VSpacer,VSwitch,VTextField,VToolbar})
